import { render, staticRenderFns } from "./IncomingModal.vue?vue&type=template&id=1ed54fc4&"
import script from "./IncomingModal.vue?vue&type=script&lang=js&"
export * from "./IncomingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports